import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import history from 'utils/history';
import { handleError } from 'utils/errorHandler';
import * as routes from 'constants/routes';
import firebaseAuth from 'services/firebase/auth';
import * as userService from 'services/firebase/user';
import { setUser, resetLogin } from 'redux/reducers/login';
import dateTime from 'utils/moment';
import { USER_STATUS } from 'constants/options';

function withAuthState(WrappedComponent) {
  class Auth extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: false,
      };
    }

    login = async (email, password) => {
      try {
        this.setState({ isLoading: true });
        let loggedUser = await firebaseAuth.loginWithEmail(email, password);
        //check if admin exist or not. If not then create new document containing admin info
        const isUserExist = await userService.checkIfUserExist(loggedUser.user.uid);
        if (!isUserExist) {
          await this.saveUserInfo(loggedUser.user);
        }
        const getUserData = (await userService.getUserById(loggedUser.user.uid)).data();
        const isClient = !getUserData.isSuperAdmin;

        history.push(isClient ? routes.CLIENT_EXPERIENCES : routes.ADMIN_HOME);
      } catch (error) {
        this.setState({ isLoading: false });
        handleError(error);
      }
    };

    logout = async () => {
      try {
        await firebaseAuth.logout();
      } catch (error) {
        handleError(error);
      }
    };

    /**
     * Store newuser info to AdminUser document
     */
    saveUserInfo = userInfo => {
      const newUser = {
        id: userInfo.uid,
        emailAddress: userInfo.email,
        isSuperAdmin: true,
        status: USER_STATUS.active,
        address: {
          city: '',
          state: '',
          zipcode: '',
          country: '',
          countryCode: '',
        },
        phoneNumber: '',
        company: '',
        businessAddress: '',
        createdAt: dateTime.getCurrentUnixTimestamp(),
      };
      return userService.createUser(newUser);
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          loginHandler={this.login}
          logoutHandler={this.logout}
          isLoading={this.state.isLoading}
        />
      );
    }
  }

  const mapStateToProps = state => ({
    loggedUserInfo: state.login,
  });

  const mapDispatchToProps = dispatch => ({
    setUser: data => dispatch(setUser(data)),
    resetLogin: () => dispatch(resetLogin()),
  });

  Auth.propTypes = {
    setUser: PropTypes.func.isRequired,
    resetLogin: PropTypes.func.isRequired,
  };

  return connect(mapStateToProps, mapDispatchToProps)(Auth);
}

export { withAuthState };
